import React from "react";
import { Activity } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

export default function FleetOperationCard({ card }) {
  return (
    <Card className="bg-card/90">
      <CardContent className="p-5">
        <div className="flex items-start justify-between gap-4">
          <div>
            <p className="text-sm font-semibold text-muted-foreground">{card.title}</p>
            <p className="mt-2 font-heading text-3xl font-bold text-foreground">{card.metric}</p>
          </div>
          <div className="rounded-2xl bg-accent/10 p-3 text-accent">
            <Activity className="h-5 w-5" />
          </div>
        </div>
        <p className="mt-4 text-sm leading-6 text-muted-foreground">{card.detail}</p>
      </CardContent>
    </Card>
  );
}